import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.includes.js";
import { COURIER_DELIVERED_STATUS } from '../config/constants/status';
export var useStatusDelivered = function useStatusDelivered(pkg) {
  return pkg.events.some(function (ev) {
    return COURIER_DELIVERED_STATUS.includes(ev === null || ev === void 0 ? void 0 : ev.code);
  });
};